import React from 'react'
import { DateTime } from 'luxon'
import { DI } from 'modules'
import TextWithLinks from './text-with-links'

function DescriptionShared({
  entity = {},
  common = {},
  className,
}) {
  const string = key => common.strings[`page.video.${key}`]
  const publishedAt = DateTime.fromISO(entity.published_at).toFormat(
    string('date.format')
  )

  let parsedDescription = ''

  if (entity.description) {
    parsedDescription = entity.description.split(/\n/g).map((text, index) => (
      <p key={index}>
        <TextWithLinks text={text} />
      </p>
    ))
  }

  function renderLocationName() {
    // if (entity.region_name) return [entity.region_name, entity.country_name].join(', ')
    return [entity.country_name, entity.location].filter(Boolean).join(', ')
  }

  return (
    <div className={`live-description ${className ? className : ''}`}>
      <h1 className="live__title">{entity.title}</h1>
      <div className="live-place">
        <span className="live__place">{renderLocationName()}</span>
      </div>
      <div className="live-update">
        {`${publishedAt} · ${string('properties.published')} `}
      </div>
      {parsedDescription && <LiveDesc description={parsedDescription} />}
    </div>
  )
}

function LiveDesc({ description }) {
  return (
    <div key="description" className="live-desc--shared">
      <div>{description}</div>
    </div>
  )
}

export default DI(['common'])(DescriptionShared)
